import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Stack,
} from "@mui/material";

const maxWidthSx = { maxWidth: "400px" };

export const Confirmation = ({
  title = "Attention",
  message = "Are you sure",
  proceedFn = () => null,
  cancelFn = () => null,
}) => {
  return (
    <Dialog
      open
      aria-labelledby="confirmation-title"
      aria-describedby="confirmation-description"
    >
      <DialogTitle id="confirmation-title" sx={{ ...maxWidthSx }}>
        {title}
      </DialogTitle>
      <DialogContent id="confirmation-description" sx={{ ...maxWidthSx }}>
        {message}
      </DialogContent>

      <Stack
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={1}
        p={2}
        sx={{ ...maxWidthSx }}
      >
        <Button variant="outlined" color="primary" onClick={cancelFn}>
          No
        </Button>
        <Button variant="contained" color="primary" onClick={proceedFn}>
          Yes
        </Button>
      </Stack>
    </Dialog>
  );
};
